module.exports = __webpack_public_path__ + "media/bet.9b9bde8f.mp3";